import React, { useState, useEffect } from 'react';
import { _eval } from "../utils";

function BaseField(props) {

    const [showField, setShowField] = useState(true);



    // Check if it's a conditional field, 
    // if the condition is fullfill, show field
    // else, hide it
    useEffect(() => {

        if (props.data.if) {

            const field = props.formData[props.data.if.field]

            if (props.data.if.is) {

                const needle = props.data.if.is
                setShowField((() => {
                    if (!field || !field.value) return false
                    else
                        if (typeof field.value == 'undefined')
                            return false

                        else if ((typeof field.value == 'string') || (typeof field.value == 'boolean'))
                            return (() => {
                                var out = false
                                needle.split('|').forEach(n => {
                                    n = n.trim()
                                    if (field.value === n) out = true
                                })
                                return out
                            })()

                        else if (Array.isArray(field.value))
                            return (() => {
                                var out = false
                                needle.split('|').forEach(n => {
                                    n = n.trim()
                                    if (field.value.includes(n)) out = true
                                })
                                return out
                            })()
                })())
            }

            if (props.data.if.stringMatch) {
                const needle = props.data.if.stringMatch
                setShowField((() => {
                    if (!field || !field.value) return false
                    return field.value.match(needle)
                })())
            }

            if(props.data.if.contains){
                const needle = props.data.if.contains
                setShowField((() => {
                    if (!field || !field.value) return false
                    return field.value.includes(needle)
                })())
            }

        }
    }, [props.formData, props.data.if]);

    return (
        <div>

            {props.data.htmlBeforeField ?
                <div dangerouslySetInnerHTML={{ __html: props.data.htmlBeforeField }} />
                : null}

            {showField ?
                props.children
                : null}

            {props.data.htmlAfterField ?
                <div dangerouslySetInnerHTML={{ __html: props.data.htmlAfterField }} />
                : null}
        </div>
    );
}

export default BaseField;